"use client";

import { ThemeProvider } from "next-themes";

/**
 * Mirrors the theme provider configuration used for non-booking app pages
 * (see apps/web/lib/getThemeProviderProps.ts) so the public legal pages follow
 * the same light/dark behaviour as the rest of the site.
 */
export const LegalThemeProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <ThemeProvider attribute="class" storageKey="app-theme" enableSystem enableColorScheme={false}>
      {children}
    </ThemeProvider>
  );
};

export default LegalThemeProvider;
